import React from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, Paper, Typography, withStyles } from '@material-ui/core';
import clsx from 'clsx';
import { withTranslation } from 'react-i18next';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepConnector from '@material-ui/core/StepConnector';
import StepButton from '@material-ui/core/StepButton';
import '../../App.css';
import MainOrganization from './components/MainOrganization';
import Tenant from './components/Tenant';
import SubOrganization from './components/SubOrganization';
import Module from './components/Module';
import User from './components/User';
import Area from './components/Area';
import Bed from './components/Bed';
import Device from './components/Device';
import Map from './components/Map';
import Router from './components/Router';
import * as wizardConstant from '../../utils/wizardConstant';

class Wizard extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    console.log('componentDidMount from wizard');
    this.props.wizard.resetActiveStep(); //อย่าลืมเปิด comment
    this.props.wizard.resetFlow();
  }

  getStepLabel(label) {
    const { t } = this.props;
    switch (label) {
      case wizardConstant.STEP_MAIN_ORGANIZATION:
        return `${t('wizard_step_main_organization')}`;
      case wizardConstant.STEP_TENANT:
        return `${t('wizard_step_tenant')}`;
      case wizardConstant.STEP_ORGANIZATION:
        return `${t('wizard_step_unit')}`;
      case wizardConstant.STEP_MODULE:
        return `${t('wizard_step_module')}`;
      case wizardConstant.STEP_USER:
        return `${t('wizard_step_user')}`;
      case wizardConstant.STEP_AREA:
        return `${t('wizard_step_area')}`;
      case wizardConstant.STEP_BED:
        return `${t('wizard_step_bed')}`;
      case wizardConstant.STEP_DEVICE:
        return `${t('wizard_step_device')}`;
      case wizardConstant.STEP_MAP:
        return `${t('wizard_step_map')}`;
      default:
        return 'Unknown step';
    }
  }

  getStepContent(step) {
    const { classes } = this.props;
    const { activeFlow, activeModuleFlow } = this.props.wizard.toJS();
    switch (step) {
      case 0:
        return '';
      case 1:
        return (
          <div className={classes.normalText}>
            <div className={activeFlow === wizardConstant.FLOW_GROUP ? classes.activeText : ''}>
              {this.getStepLabel(wizardConstant.STEP_ORGANIZATION)}
            </div>
            <div className={activeFlow === wizardConstant.FLOW_USER ? classes.activeText : ''}>
              {this.getStepLabel(wizardConstant.STEP_USER)}
            </div>
            <div className={activeFlow === wizardConstant.FLOW_AREA ? classes.activeText : ''}>
              {this.getStepLabel(wizardConstant.STEP_AREA)}
            </div>
          </div>
        );
      case 2:
        return '';
      case 3:
        return (
          <div className={classes.normalText}>
            <div className={activeModuleFlow === wizardConstant.FLOW_BED ? classes.activeText : ''}>
              {this.getStepLabel(wizardConstant.STEP_BED)}
            </div>
            <div className={activeModuleFlow === wizardConstant.FLOW_DEVICE ? classes.activeText : ''}>
              {this.getStepLabel(wizardConstant.STEP_DEVICE)}
            </div>
            <div className={activeModuleFlow === wizardConstant.FLOW_MAP ? classes.activeText : ''}>
              {this.getStepLabel(wizardConstant.STEP_MAP)}
            </div>
          </div>
        );
      case 4:
        return '';
      default:
        return 'Unknown step';
    }
  }

  handleDisplaySteps = (step) => {
    const { activeFlow, activeModuleFlow, isRouterStep } = this.props.wizard.toJS();
    switch (step) {
      case 0:
        return <MainOrganization />;
      case 1:
        return <Tenant />;
      case 2:
        if (activeFlow === wizardConstant.FLOW_GROUP) {
          return <SubOrganization />;
        } else if (activeFlow === wizardConstant.FLOW_USER) {
          return <User />;
        } else if (activeFlow === wizardConstant.FLOW_AREA) {
          return <Area />;
        } else {
          throw new Error('Unknown step');
        }
      case 3:
        return <Module />;
      case 4:
        if (activeModuleFlow === wizardConstant.FLOW_BED) {
          return <Bed />;
        } else if (activeModuleFlow === wizardConstant.FLOW_DEVICE) {
          return <Device />;
        } else if (activeModuleFlow === wizardConstant.FLOW_MAP) {
          return isRouterStep ? <Router /> : <Map />;
        } else {
          throw new Error('Unknown step');
        }
      default:
        throw new Error('Unknown step');
    }
  };

  handleClickStep = (step) => () => {
    // if step === 0 || 1 set defaultFlow else do not thing
    if (step === 0 || step === 1) {
      this.props.wizard.resetFlow();
    }

    this.props.wizard.setActiveStep(step);
    // set navbar
    const { navigations } = this.props.wizard.toJS();
    navigations.forEach((nav) => {
      if (nav.wizardPage === 'unit') {
        nav.wizardName = 'wizard_step_unit';
      }
      if (nav.wizardPage === 'module') {
        nav.wizardName = 'wizard_step_module';
      }
    });
    const nav = navigations.filter((nav) => nav.wizardStep < step);
    this.props.wizard.setNavigation(nav);
    this.props.wizard.setRouterStep(false);
  };

  render() {
    const { classes, t } = this.props;
    const { activeStep, activeFlowSteps } = this.props.wizard.toJS();

    const connector = (
      <StepConnector
        classes={{
          active: classes.connectorActive,
          completed: classes.connectorCompleted,
          disabled: classes.connectorDisabled,
          line: classes.connectorLine,
        }}
      />
    );

    const CustomStepIcon = (props) => {
      const { active, completed } = props;

      // ค่าในแต่ละ Step ที่จะแทนเครื่องหมายถูก
      // const icons = {
      //   1: '1',
      //   2: '2',
      //   3: '3',
      //   4: '4',
      //   5: '5',
      // };

      return (
        <div
          className={clsx(classes.stepIconRoot, {
            [classes.active]: active,
            [classes.completed]: completed,
          })}
        >
          {/* {icons[String(props.icon)]} */}
        </div>
      );
    };

    return (
      <React.Fragment>
        <Grid container className={classes.wrapContainer}>
          <div className={classes.wrapStepper}>
            <Typography className={classes.stepHeader}>{t('management_wizard')}</Typography>
            <div className={classes.root}>
              <Stepper
                activeStep={activeStep}
                connector={connector}
                orientation='vertical'
                style={{ backgroundColor: 'transparent' }}
              >
                {activeFlowSteps.map((label, index) => {
                  return (
                    <Step key={index}>
                      <StepButton
                        id={`step-${index}`}
                        onClick={this.handleClickStep(index)}
                        style={{ position: 'relative' }}
                      >
                        <StepLabel StepIconComponent={CustomStepIcon}>
                          <div
                            className={classes.stepLabel}
                            style={{ color: activeStep === index ? '#005050' : '#858585' }}
                          >
                            {' '}
                            {this.getStepLabel(label)}
                          </div>
                          <div style={{ position: 'absolute' }}>{this.getStepContent(index)}</div>
                        </StepLabel>
                      </StepButton>
                    </Step>
                  );
                })}
              </Stepper>
            </div>
          </div>
          <div className={classes.wrapPaper}>
            <Paper className={classes.paper}>
              {this.handleDisplaySteps(activeStep)}
              {/* <Device/> */}
            </Paper>
          </div>
        </Grid>
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  root: {
    width: '100%',
  },
  wrapContainer: {
    padding: '15px 10px',
  },
  wrapStepper: {
    paddingLeft: '15px',
    width: '20%',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  wrapPaper: {
    paddingRight: '5px',
    width: '80%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  paper: {
    width: '100%',
    // height: "576px",
    padding: '30px 40px',
  },
  stepHeader: {
    color: theme.palette.text.header,
    marginTop: 30,
    fontWeight: 500,
    fontSize: 24,
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
  stepLabel: {
    fontSize: 18,
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 14,
    },
  },
  connectorActive: {
    '& $connectorLine': {
      width: 4.5,
      minHeight: 70,
      marginBottom: '-12px',
      marginLeft: '-4px',
      marginTop: '-4px',
      backgroundColor: theme.palette.success.main,
      border: 'none',
      [theme.breakpoints.down('md')]: {
        marginTop: '-15px',
        minHeight: 80,
      },
    },
  },
  connectorCompleted: {
    '& $connectorLine': {
      width: 4.5,
      minHeight: 70,
      marginLeft: '-4px',
      marginBottom: '-12px',
      marginTop: '-4px',
      backgroundColor: theme.palette.success.main,
      border: 'none',
      [theme.breakpoints.down('md')]: {
        marginTop: '-15px',
        minHeight: 80,
      },
    },
  },
  connectorDisabled: {
    '& $connectorLine': {
      width: 4.5,
      minHeight: 70,
      marginLeft: '-4px',
      marginBottom: '-12px',
      marginTop: '-4px',
      backgroundColor: '#D7D7D7',
      border: 'none',
      [theme.breakpoints.down('md')]: {
        marginTop: '-15px',
        minHeight: 80,
      },
    },
  },
  connectorLine: {
    '& $connectorLine': {
      width: 4.5,
      minHeight: 70,
      marginLeft: '-2px',
      // backgroundColor: "#BDBDBD",
      border: 'none',
      backgroundColor: '#D7D7D7',
      [theme.breakpoints.down('md')]: {
        minHeight: 80,
      },
    },
  },
  stepIconRoot: {
    backgroundColor: '#D7D7D7', //"#fff",
    // boxShadow: "inset 0 0 0 0.25rem #D7D7D7",
    boxShadow: `inset 0 0 0 0.25rem #D7D7D7`,
    zIndex: 1,
    color: '#D7D7D7',
    width: '1.25rem',
    height: '1.25rem',
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1.75rem',
    lineHeight: '1.75rem',
    fontWeight: 500,
    cursor: 'pointer',
  },
  stepIconRootBackup: {
    backgroundColor: '#fff',
    boxShadow: 'inset 0 0 0 0.25rem #BDBDBD',
    zIndex: 1,
    color: '#BDBDBD',
    width: '2.5rem',
    height: '2.5rem',
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1.75rem',
    lineHeight: '1.75rem',
    fontWeight: 500,
    cursor: 'pointer',
  },
  active: {
    // color: "#005050",
    // backgroundColor: "#fff",
    // boxShadow: `inset 0 0 0 0.25rem ${theme.palette.success.main}`,
    backgroundColor: theme.palette.success.main,
    boxShadow: `inset 0 0 0 0.25rem ${theme.palette.success.main}`,
    border: '5px solid rgb(219 237 237 / 40%)',
    width: '1rem',
    height: '1rem',
    marginLeft: '-3px',
    marginRight: '-2px',
  },
  completed: {
    // color: "#005050",
    // backgroundColor: "#fff",
    // boxShadow: `inset 0 0 0 0.25rem ${theme.palette.success.main}`,
    backgroundColor: theme.palette.success.main,
    boxShadow: `inset 0 0 0 0.25rem ${theme.palette.success.main}`,
  },
  normalText: {
    color: '#858585',
    fontSize: 14,
    fontWeight: 400,
    textAlign: 'left',
    cursor: 'default',
  },
  activeText: {
    color: theme.palette.success.main,
  },
});

export const page = inject('wizard')(observer(Wizard));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
